import React from 'react'
import './Rent.scss'

function Rent() {
  return (
    <div>Rent</div>
  )
}

export default Rent